import { OUTFIT_STYLE_OPTIONS } from '../OUTFIT_STYLE_OPTIONS';
import { OutfitStyleOptionIdType } from '../types';

const DEFAULT: OutfitStyleOptionIdType = 'latex_seductress';

export const getOutfitStyleIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): OutfitStyleOptionIdType | null => {
  const id = OUTFIT_STYLE_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
